/* global axios */
import ApiClient from './ApiClient';

class SidebarCountsAPI extends ApiClient {
  constructor() {
    super('sidebar_counts', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new SidebarCountsAPI();
